module.exports = __webpack_public_path__ + "static/img/66.19ed085.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/66.png
// module id = dpRj
// module chunks = 1